module.exports = __webpack_public_path__ + "img/process-robot-animated.5e1080e0.gif";